<textarea
    kui-input="{{ field.id }}"
    placeholder="{{ field.placeholder }}"
    id="{{ field.id }}"
    #textareaField="ngModel"
    [minlength]="field.min || 0"
    [maxlength]="field.max || 1024"
    [ngModel]="values[field.id]"
    (ngModelChange)="changeValue($event)"
    [required]="field.required"
    [rows]="rows"
    [class.border-danger]="error || (textareaField.invalid && (textareaField.dirty || textareaField.touched))"
></textarea>
@if (textareaField.invalid && (textareaField.dirty || textareaField.touched)) {
    <div class="invalid-feedback d-block">
        @if (textareaField.errors["required"]) {
            <div>
                {{ "FORMS.SHARED.REQUIRED" | translate: { field: field.title } }}
            </div>
        }
        @if (textareaField.errors["minlength"]) {
            <div>
                {{ "FORMS.TEXT.MIN" | translate: { field: field.title, min: field.min } }}
            </div>
        }
    </div>
}
@if (error) {
    <div class="invalid-feedback d-block">
        <div>{{ error }}</div>
    </div>
}
